/**
 * AccumDist — Acumulação & Distribuição de Chaikin.
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLOscilators.cs, classe
 * FML.AD — ≠ williamsad do odin). Painel próprio:
 *
 *   AD = SUM( ((C−L) − (H−C)) / (H−L) · VOL , 0 )   (soma cumulativa)
 *   M  = MA(AD, N)
 *
 * Usa VOLUME → desembrulhar o objeto {volume,direction} que o indicador Volume
 * deixa em d.volume no pipeline (família E1). Barras flat (H==L) → 0/0 = NaN
 * (o SUM cumulativo do engine pula NaN e continua). Ordem de operações do
 * engine preservada (div antes de mul). Paridade em __tests__/accumDist.silverlight.test.js.
 */
import { sub, div, mul, sum, ma } from "./silverlightDsl";
import { AccumDist as defaultOptions } from "./defaultOptionsForComputation";

const unwrapVolume = (raw) =>
  typeof raw === "object" && raw !== null ? raw.volume : raw;

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { n } = options;
    const num = (v) => (Number.isFinite(v) ? v : NaN);
    const h = data.map((d) => num(d.high));
    const l = data.map((d) => num(d.low));
    const c = data.map((d) => num(d.close));
    const vol = data.map((d) => num(unwrapVolume(d.volume)));

    // ((C-L)-(H-C)) / (H-L) * VOL — mesma ordem do engine.
    const mfv = mul(div(sub(sub(c, l), sub(h, c)), sub(h, l)), vol);
    const ad = sum(mfv, 0); // cumulativo
    const m = ma(ad, n);

    return ad.map((adv, i) => {
      const adOut = Number.isFinite(adv) ? adv : undefined;
      const mOut = Number.isFinite(m[i]) ? m[i] : undefined;
      if (adOut === undefined && mOut === undefined) return undefined;
      return { ad: adOut, m: mOut };
    });
  }

  calculator.undefinedLength = function () {
    // AD começa na barra 0 (cumulativo); M acrescenta N-1. Warm-up efetivo ~ 0
    // (barras flat viram undefined pontualmente, tratadas por barra).
    return 0;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
